import { render, staticRenderFns } from "./TextRegulamento.vue?vue&type=template&id=3b29b6fb&scoped=true&"
import script from "./TextRegulamento.vue?vue&type=script&lang=js&"
export * from "./TextRegulamento.vue?vue&type=script&lang=js&"
import style0 from "./TextRegulamento.vue?vue&type=style&index=0&id=3b29b6fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b29b6fb",
  null
  
)

export default component.exports